import React from 'react';
import * as Image from '../../assets/images'

export default function Footer() {

  const scrollToTop = () =>  {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling effect
    });
  }

  return (
    <div>
      <div className="container-fluid copybg mainbgcolor">
        <div className="container mycontainer space3">
          <div className="row">
            <div className="col-md-11 col-sm-11 col-xs-12 ">
              <center>
                <img src={Image.copyimg} className="max" alt="Demand Edge" /><br />©2025 Quation Solutions Pvt. Ltd., All rights reserved
              </center>
            </div>
            <div className="col-md-1 col-sm-1 col-xs-12">
              <p id="bottom">
                <a href="#" onClick={scrollToTop} aria-label="DE">
                  <iconify-icon icon="tabler:arrow-top-circle" className="scrollerbottom animate__animated animate__infinite animate__slideInUp"></iconify-icon>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
